import { ValidationError } from 'yup';
import { ICS2InformationExchangeMessages } from 'store/declarations/eu/ics2/ICS2InformationExchangeMessages';
import { Ics2CustomsRequest, Ics2Referral } from 'store/declarations/eu/ics2/customs-requests/types';
import { fromReferralDraft as fromRfiDraft } from './IE3Q02/types';
import { validationSchema as rfiSchema } from './IE3Q02/validationSchema';
import { fromReferralDraft as fromRfsDraft } from './IE3Q03/types';
import { validationSchema as rfsSchema } from './IE3Q03/validationSchema';

export type DraftContext = {
    attachmentCount: number;
    unverifiedAttachmentCount: number;
    postcodeOptionalCountries: string[];
};

export const validateReferralDraft = (
    request: Ics2CustomsRequest,
    referral: Ics2Referral,
    context: DraftContext
): string[] => {
    if (!referral.draftVersion) return [];

    const isScreening = request.messageType === ICS2InformationExchangeMessages.IE3Q03;

    const errors: string[] = [];
    try {
        if (isScreening) {
            rfsSchema.validateSync(fromRfsDraft(referral), {
                abortEarly: false,
                context: { postcodeOptionalCountries: context.postcodeOptionalCountries },
            });
        } else {
            rfiSchema.validateSync(fromRfiDraft(referral), {
                abortEarly: false,
                context: { attachmentCount: context.attachmentCount },
            });
        }
    } catch (error) {
        if (!(error instanceof ValidationError)) throw error;
        errors.push(...Array.from(new Set(error.errors)));
    }

    if (context.unverifiedAttachmentCount > 0) {
        errors.push(
            context.unverifiedAttachmentCount === 1
                ? '1 attached file has not passed its security check yet.'
                : `${context.unverifiedAttachmentCount} attached files have not passed their security checks yet.`
        );
    }

    return errors;
};
